(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["marv-hat-game"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('marv-hat-game')) {
  customElements.define('marv-hat-game', class extends HTMLElement {
    connectedCallback() {
      if (this.started) return;
      this.started = true;
      this.key = 'marv_magic_hat_game_seen_v1';
      this.test = new URLSearchParams(location.search).get('marvhatgame') === 'test';
      if (new URLSearchParams(location.search).get('marvhatgame') === 'activated') return;
      if (this.dataset.editor === 'true' && !this.test) return;
      this.dialog = this.querySelector('dialog');
      this.hats = [...this.querySelectorAll('.marv-hat-pick')];
      this.querySelector('.marv-hat-close').addEventListener('click', () => this.dialog.close());
      this.dialog.addEventListener('close', () => { this.running = false; this.hats.forEach(h => h.getAnimations().forEach(a => a.cancel())); });
      this.hats.forEach((hat, i) => hat.addEventListener('click', () => this.choose(i)));
      this.querySelector('.marv-hat-copy').addEventListener('click', async () => {
        const status = this.querySelector('.marv-hat-copy-status');
        try { await navigator.clipboard.writeText(this.code); status.textContent = this.dataset.copied; }
        catch { const selection = getSelection(); const range = document.createRange(); range.selectNodeContents(this.querySelector('.marv-hat-code')); selection.removeAllRanges(); selection.addRange(range); status.textContent = this.dataset.manual; }
      });
      const begin = () => {
        if (!this.isConnected || (!this.test && this.seen())) return;
        let remaining = this.test ? 350 : Number(this.dataset.delay) * 1000;
        let last = performance.now();
        this.timer = setInterval(() => {
          const now = performance.now();
          if (!document.hidden) remaining -= now - last;
          last = now;
          if (!this.test && this.seen()) { clearInterval(this.timer); return; }
          if (remaining <= 0 && !document.hidden && !this.blocked()) { clearInterval(this.timer); this.open(); }
        }, 250);
      };
      if (document.readyState === 'complete') begin(); else window.addEventListener('load', begin, { once: true });
    }
    disconnectedCallback() { clearInterval(this.timer); this.running = false; if(this.dialog?.open) this.dialog.close(); }
    seen() { try { return localStorage.getItem(this.key) === '1'; } catch { return this.shown; } }
    visible(el) {
      if (el.closest('details:not([open])')) return false;
      const css = getComputedStyle(el), r = el.getBoundingClientRect();
      return css.display !== 'none' && css.visibility !== 'hidden' && Number(css.opacity) !== 0 && r.width > 20 && r.height > 20 && r.bottom > 0 && r.top < innerHeight && r.right > 0 && r.left < innerWidth;
    }
    blocked() {
      const selectors = 'dialog[open],[role="dialog"],[aria-modal="true"],cart-drawer.active,details[open].menu-opening';
      if ([...document.querySelectorAll(selectors)].some(el => !this.contains(el) && this.visible(el))) return true;
      const cmp = document.querySelector('pandectes-cmp')?.shadowRoot;
      if (cmp && [...cmp.children].some(el => el.tagName !== 'STYLE' && !el.matches('button.widget') && this.visible(el))) return true;
      return false;
    }
    random(n) {
      const data = new Uint32Array(1), limit = Math.floor(4294967296 / n) * n;
      do { crypto.getRandomValues(data); } while (data[0] >= limit);
      return data[0] % n;
    }
    async open() {
      this.hats.forEach(h => { const img = h.querySelector('img'); img.src = img.dataset.src; });
      this.rewards = [5, 7, 10];
      for (let i = 2; i > 0; i--) { const j = this.random(i + 1); [this.rewards[i], this.rewards[j]] = [this.rewards[j], this.rewards[i]]; }
      this.dialog.showModal();
      this.shown = true;
      if (!this.test) { try { localStorage.setItem(this.key, '1'); } catch {} }
      this.running = true;
      this.state = 'shuffling';
      const wait = ms => new Promise(resolve => setTimeout(resolve, ms));
      await wait(500);
      const positions = [0, 1, 2];
      if (!matchMedia('(prefers-reduced-motion: reduce)').matches) {
        for (const duration of [500, 450, 400, 350, 350, 400, 550]) {
          if (!this.running) return;
          const a = this.random(3), b = (a + 1 + this.random(2)) % 3;
          const move = (i, destination, arc) => {
            const from = positions[i] * 100, to = destination * 100;
            return this.hats[i].animate([{ transform:`translate(${from}%,0)` },{ transform:`translate(${(from+to)/2}%,${arc}px)` },{ transform:`translate(${to}%,0)` }],{duration,easing:'ease-in-out',fill:'forwards'});
          };
          const animations = [move(a, positions[b], -16),move(b, positions[a], 10)];
          await Promise.all(animations.map(animation => animation.finished.catch(() => {})));
          [positions[a], positions[b]] = [positions[b], positions[a]];
          this.hats.forEach((hat,i) => hat.style.setProperty('--hat-slot',positions[i]));
          animations.forEach(animation => animation.cancel());
        }
      }
      if (!this.running) return;
      positions.forEach((slot,i) => { this.hats[i].style.setProperty('--hat-slot',slot); });
      this.state = 'choosing';
      this.querySelector('.marv-hat-status').textContent = this.dataset.choose;
      this.hats.forEach(h => h.disabled = false);
    }
    choose(i) {
      if (this.state !== 'choosing') return;
      this.state = 'won';
      this.hats.forEach(h => h.disabled = true);
      const percent = this.rewards[i];
      this.code = 'MAGIE' + percent;
      const selected = this.hats[i];
      selected.querySelector('.marv-hat-prize').textContent = percent + ' %';
      selected.classList.add('is-chosen');
      this.querySelector('.marv-hat-status').textContent = '';
      this.querySelector('.marv-hat-win').textContent = this.dataset.win.replace('{percent}',percent);
      this.querySelector('.marv-hat-code').textContent = this.code;
      const redirect = location.pathname + '?marvhatgame=activated';
      this.querySelector('.marv-hat-activate').href = '/discount/' + this.code + '?redirect=' + encodeURIComponent(redirect);
      this.querySelector('.marv-hat-result').hidden = false;
      this.querySelector('.marv-hat-win').focus({preventScroll:true});
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
